const versionsViewTemplate = `
<div>
   <div  class="container project-versions">
        <div style="display:none">
        </div>
       <div class="row">
           <h2 class="gridh2"><span style="color:#008aff">Project Versions</span></h2>
           <table class="table table-striped">
                <thead>
                    <tr>
                        <td>Project</td>
                        <td>Version</td>
                        <td>Dependencies</td>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in displayData | orderBy:'name'">

                        <td ng-if="item.dataAvailable == true">
                            <span style="padding-left: 20px;">
                            <a ng-href="{{item.url}}">{{item.name}}</a>
                            </span>
                        </td>

                        <td ng-if="item.dataAvailable == false">
                            <span style="padding-left: 20px; color:red;">
                            {{item.name}}
                            </span>
                        </td>



                        <td ng-if="item.dataAvailable == true"><span style="color:#008aff">{{item.version}}</span></td>
                        <td ng-if="item.dataAvailable == false"><span style="color:red">Data Unavailable</span></td>

                        <td ng-if="item.dataAvailable == true" ><a ng-href="{{item.url}}">View Dependencies</a></td>
                        <td ng-if="item.dataAvailable == false"><span style="color:red">Data Unavailable</span></td>

                    </tr>
                </tbody>
           </table>
       </div>
   </div>
</div>
`;
export default versionsViewTemplate;
